// Constantes de gameplay partagées par le moteur et l'interface

// Une case ne descend jamais sous MIN_CELL_PX pixels CSS (lisibilité mobile)
export const MIN_CELL_PX = 18;
export const MAX_GRID_SIZE = 16; // 16 × 16 au plus : la taille du dernier niveau (FINAL_LEVEL)
// Dernier niveau : le gagner, c'est gagner la partie, et pouvoir inscrire son score au Hall of Fame (docs/GAMEPLAY.md#end-of-the-game)
export const FINAL_LEVEL = 8;
export const MIN_GRID_SIZE = 5;
// Points d'un niveau : POINTS_PER_CELL par case du plus court chemin (de la distance à l'adversaire dans le noir)
export const POINTS_PER_CELL = 10;

// Chrono : plancher à 250 ms, une fois la taille plafonnée c'est la vitesse qui porte la difficulté
export const TIMER_BASE_MS = 1000;
export const TIMER_STEP_MS = 50;
export const TIMER_MIN_MS = 250;
// Premiers niveaux : le rat est ralenti (x2 au niveau 1), l'écart se résorbe jusqu'au niveau indiqué
export const RAT_EARLY_SLOWDOWN = 2;
export const RAT_EARLY_LEVELS = 6;

// Souris traînée au doigt (ou clic maintenu) : mouvement libre qui suit le doigt 1:1, sans
// traverser les murs (corps de MOUSE_RADIUS case), puis elle se pose au centre de sa case au
// relâchement. À la souris, le glisser commence après GRAB_START_PX (un simple clic reste un clic).
export const MOUSE_RADIUS = 0.3;
export const GRAB_START_PX = 4;

// Affichage : la souris glisse d'une case à l'autre à GLIDE_CELLS_PER_S cases/s, plus vite quand
// des cases attendent (+GLIDE_CATCH_UP par case en attente) — voir core/glide.js
export const GLIDE_CELLS_PER_S = 16;
export const GLIDE_CATCH_UP = 0.6;

// Traces de pattes de la souris (core/trail.js) : une empreinte toutes les TRAIL_SPACING cases
// parcourues, à TRAIL_SIDE_OFFSET case de part et d'autre de sa trajectoire ; au-delà de
// TRAIL_MAX_PRINTS, les plus anciennes disparaissent.
export const TRAIL_SPACING = 0.5;
export const TRAIL_SIDE_OFFSET = 0.1;
export const TRAIL_MAX_PRINTS = 600;

// Glissement à deux doigts au trackpad (voir core/swipe.js) : un pas par case de trajet, jamais moins de
// SWIPE_MIN_PX (le tremblement du doigt ne compte pas) ni plus que le réglage dev playerSpeed.
// Le geste doit pencher d'au moins SWIPE_SECONDARY_RATIO pas de côté pour tourner contre un mur.
export const SWIPE_MIN_PX = 14;
export const SWIPE_SECONDARY_RATIO = 0.4;

// Trackpad : glisser à deux doigts (événements wheel) déplace la souris comme un glissement au
// doigt. Un pas tous les (pas du glissement) × WHEEL_THRESHOLD_FACTOR px de défilement ; un silence de
// WHEEL_GESTURE_GAP_MS sépare deux gestes ; sous WHEEL_INERTIA_RATIO du pic, des valeurs qui
// décroissent sont l'inertie de macOS (doigts déjà levés) et sont ignorées.
export const WHEEL_THRESHOLD_FACTOR = 1.5;
export const WHEEL_GESTURE_GAP_MS = 150;
export const WHEEL_INERTIA_RATIO = 0.4;

// Bulles d'aide (rat arrêté à mi-chemin tant que la souris n'a pas bougé) : durée de chacune
export const HINT_BUBBLE_HOLD_MS = 3200;

// Hall of Fame : lignes affichées par liste (la synthèse en garde 30, functions/src/insert.js)
export const LEADERBOARD_DISPLAY_LIMIT = 10;

// Règles du profil, communes au jeu et aux fonctions (functions/src/profile.js)
export { PSEUDO_MIN_LENGTH, PSEUDO_MAX_LENGTH, CITY_MAX_LENGTH } from '../../functions/src/profile.js';

// Géolocalisation hors ligne (core/region.js#offlinePlace), comme ZERO SLANG : pays et villes de référence reconnus sans réseau
export const LYON = { lat: 45.764, lon: 4.8357 };
export const LYON_RADIUS_KM = 25;
export const FRANCE_BOUNDS = { south: 41.3, north: 51.2, west: -5.2, east: 9.6 };
export const SANTA_CRUZ = { lat: 36.9741, lon: -122.0308 };
export const SANTA_CRUZ_RADIUS_KM = 20;
export const USA_BOUNDS = { south: 24.4, north: 49.4, west: -124.9, east: -66.9 };

// Délai avant l'apparition du bouton d'action sur l'écran de fin de niveau
export const OVERLAY_BUTTON_DELAY_MS = 1500;

// Popup d'installation au lancement : proposée au plus une fois tous les N jours
export const INSTALL_OFFER_INTERVAL_DAYS = 60;

// Double-tap : ouvrir les réglages dev (bloc "Niveau") ou remettre le son au maximum (bouton volume)
export const DOUBLE_TAP_MS = 400;

// Réglages dev par défaut (modifiables via le menu caché)
export const DEFAULT_DEV_SETTINGS = Object.freeze({
  sizeStep: 1.5,      // Cases ajoutées par niveau (arrondi) : 5 × 5 au niveau 1, 16 × 16 au niveau 8
  twistiness: 0.8,    // 0 = longs couloirs, 1 = labyrinthe très chaotique
  speedFactor: 2.0,   // Multiplicateur de vitesse du chrono (rat)
  musicBpm: 120,      // Tempo de la musique
  startLevel: 1,      // Niveau de redémarrage
  deadEnds: 0.4,      // Ratio d'impasses conservées (1.0 = toutes, 0.0 = aucune)
  playerSpeed: 40,    // Glissement max pour un pas, en px (grandes cases ; plus bas = plus rapide)
});

export const STORAGE_KEYS = Object.freeze({
  profile: 'zeroMaze.profile',
  leaderboard: 'zeroMaze.localHallOfFame', // Hall of Fame tenu sur l'appareil (hors ligne, réglages modifiés)
  hallOfFameId: 'zeroMaze.hallOfFameId',   // identifiant du joueur dans le Hall of Fame en ligne (rendu par submitScore)
  language: 'zeroMaze.language',
  installOfferedAt: 'zeroMaze.installOfferedAt',
});
